import { useState } from "react";
import { updateUserVerificationCheck } from "services/user.service";
import { VerificationCheck } from "types/user.type";

export interface Props {
  check: VerificationCheck;
  userId: string;
}
export default function VerificationChecks({ check, userId }: Props) {
  const [verificationCheck, setVerificationCheck] = useState<VerificationCheck>(
    check || {
      identity: false,
      guarantor: false,
      photo: false,
      interview: false,
    }
  );

  const handleVerificationCheck = async (
    key: keyof VerificationCheck,
    value: boolean
  ) => {
    // @ts-ignore
    const payload: VerificationCheck = {
      ...verificationCheck,
      [key]: value,
    };
    setVerificationCheck(payload);
    await updateUserVerificationCheck(userId, payload);
  };

  return (
    <div className=" p-4 flex flex-col gap-4">
      <div className=" font-medium text-sm font-body flex items-center gap-3">
        Identity verification:
        <input
          className=" w-4 h-4 checked:accent-blue-500"
          type="checkbox"
          checked={verificationCheck?.identity!}
          onChange={({ target }) =>
            handleVerificationCheck("identity", target.checked)
          }
        />
      </div>

      <div className=" font-medium text-sm font-body flex items-center gap-3">
        Guarantor verification:
        <input
          className=" w-4 h-4 checked:accent-blue-500"
          type="checkbox"
          checked={verificationCheck?.guarantor!}
          onChange={({ target }) =>
            handleVerificationCheck("guarantor", target.checked)
          }
        />
      </div>

      <div className=" font-medium text-sm font-body flex items-center gap-3">
        Photo verification:
        <input
          className=" w-4 h-4 checked:accent-blue-500"
          type="checkbox"
          checked={verificationCheck?.photo!}
          onChange={({ target }) =>
            handleVerificationCheck("photo", target.checked)
          }
        />
      </div>

      <div className=" font-medium text-sm font-body flex items-center gap-3">
        Interviewed:
        <input
          className=" w-4 h-4 checked:accent-blue-500"
          type="checkbox"
          checked={verificationCheck?.interview!}
          onChange={({ target }) =>
            handleVerificationCheck("interview", target.checked)
          }
        />
      </div>
    </div>
  );
}
